import React from 'react';
import ThreejsDrawingSystem from 'drawing/threejs/ThreejsDrawingSystem';
import './Threejs.css';

type Props = {
    drawingSystem: ThreejsDrawingSystem;
};

const speedValues = [1, 2, 3, 4, 5, 10, 20];

const AnimationController = ({ drawingSystem }: Props) => {
    const [intervalId, setIntervalId] = React.useState<NodeJS.Timeout | null>(null);
    const [speed, setSpeed] = React.useState<number>(1);

    const cancelAnimation = (): void => {
        if (intervalId !== null) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
    };

    const forward = (): void => {
        drawingSystem.geometryForward();
        drawingSystem.render();
    };

    const backward = (): void => {
        drawingSystem.geometryBackward();
        drawingSystem.render();
    };

    const animate = (fn: () => void): void => {
        const timeout = 1000 / speed;

        cancelAnimation();
        const intervalId = setInterval(fn, timeout);
        setIntervalId(intervalId);
    };

    const backwardClick = (): void => {
        cancelAnimation();
        for (let i = 0; i < speed; i++) {
            backward();
        }
    };

    const forwardClick = (): void => {
        cancelAnimation();
        for (let i = 0; i < speed; i++) {
            forward();
        }
    };

    const dropDown = (
        <select
            className="animationItem"
            onChange={(event: React.FormEvent<HTMLSelectElement>): void =>
                setSpeed(parseInt(event.currentTarget.value))
            }
        >
            {speedValues.map((value: number) => (
                <option selected={value === speed} key={value} value={value}>
                    {value}x
                </option>
            ))}
        </select>
    );

    return (
        <>
            <input className="animationItem" type="button" value="◄◄" onClick={(): void => animate(backward)} />
            <input className="animationItem" type="button" value="◄" onClick={backwardClick} />
            {intervalId !== null && <input type="button" value="■" onClick={cancelAnimation} />}
            {intervalId === null && dropDown}
            <input className="animationItem" type="button" value="►" onClick={forwardClick} />
            <input className="animationItem" type="button" value="►►" onClick={(): void => animate(forward)} />
        </>
    );
};

export default AnimationController;
